import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ArrowLeftIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M19 11H7.4l5.3-5.3c.4-.4.4-1 0-1.4a1 1 0 0 0-1.4 0l-7 7-.2.3v.7l.2.3 7 7c.4.3 1 .3 1.4 0 .4-.4.4-1 0-1.5l-5.3-5.3H19c.5 0 1-.4 1-1 0-.5-.4-.8-1-.8Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ArrowLeftIcon;
